import React, { useRef, useState } from 'react';
import InputTitleView from './InputTitleView';
import { uploadFileApplyMyImages } from 'Api/endpoints/Recruitment';
import { useError } from 'Api/hooks/useError';
import { CircularProgress } from '@mui/material';
import OneImagePopup from 'Components/Popup/OneImagePopup';
import { getImageSet } from 'Util/DataUtils';
import icPhoto from 'Assets/img/recruitment/ic_photo.png';
import icPhoto2 from 'Assets/img/recruitment/ic_photo@2x.png';
import icPhoto3 from 'Assets/img/recruitment/ic_photo@3x.png';
import icSearch from 'Assets/img/recruitment/ic_search_white.png';
import icSearch2 from 'Assets/img/recruitment/ic_search_white@2x.png';
import icSearch3 from 'Assets/img/recruitment/ic_search_white@3x.png';
import icClose from 'Assets/img/recruitment/ic_close_white.png';
import icClose2 from 'Assets/img/recruitment/ic_close_white@2x.png';
import icClose3 from 'Assets/img/recruitment/ic_close_white@3x.png';

const photoImgs = getImageSet([icPhoto, icPhoto2, icPhoto3]);
const searchImgs = getImageSet([icSearch, icSearch2, icSearch3]);
const closeImgs = getImageSet([icClose, icClose2, icClose3]);

const ImageInputView = ({ title = '', required = false, subTitle = '', name, value, onChange }) => {
  const inputRef = useRef();
  const [loading, setLoading] = useState(false);
  const [imageModal, setImageModal] = useState(false);
  const { showErrorPopup } = useError();

  const uploadImage = async image => {
    try {
      const result = await uploadFileApplyMyImages(image);
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message });
        return null;
      }
      return result.data.image.origin_path;
    } catch (e) {
      console.log(e);
    }
  };

  const onChangeImage = async ({ file }) => {
    try {
      setLoading(true);
      const result = await uploadImage(file);
      if (result) {
        onChange({ name, value: result });
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <div className="recruitment-image-input-view">
        <InputTitleView title={title} required={required} subTitle={subTitle} />
        <div className="recruitment-image-input-view-input-wrapper">
          <input type="file" ref={inputRef} onChange={e => onChangeImage({ file: e.target.files[0] })} accept="image/*" multiple style={{ display: 'none' }} />
          {loading ? (
            <div className="portfolios-photo-input">
              <CircularProgress size={26} />
            </div>
          ) : value ? (
            <div className="portfolios-photo-wrapper">
              <div
                className="portfolios-photo"
                onClick={() => {
                  inputRef.current.click();
                }}
              >
                <img src={value} alt={`logo`} />
              </div>
              <div className="portfolios-photo-extra">
                <div
                  className="portfolios-photo-icon"
                  onClick={() => {
                    setImageModal(true);
                  }}
                >
                  <img {...searchImgs} alt="search" />
                </div>
                <div className="portfolios-photo-icon" onClick={() => onChange({ name, value: '' })}>
                  <img {...closeImgs} alt="close" />
                </div>
              </div>
            </div>
          ) : (
            <div
              className="portfolios-photo-input"
              onClick={() => {
                inputRef.current.click();
              }}
            >
              <img {...photoImgs} alt="photos" />
            </div>
          )}
        </div>
      </div>
      <OneImagePopup image={value} modal={imageModal} onClose={() => setImageModal(false)} />
    </>
  );
};

export default ImageInputView;
